<template>
  <div>
    <input
      type="range"
      min="10"
      max="1000"
      step="10"
      value="300"
      data-orientation="horizontal"
      class="range-slider"
    />
  </div>
</template>

<script>
import $ from "jquery";
import rangeslider from "rangeslider.js";

$(document).ready(function() {
  $(".range-slider").rangeslider({
    onSlide: function(position, value) {
      console.log(value);
    }
  });
});

export default {
  name: "RangeSlider",
  data() {
    return {
      exampleUserID: "ZgU6g0zy",
      user_id: null
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/RangeSlider.vue